<template>
  <div>
    <h1 class="main-header" v-translate translate-context="refundType">Create</h1>
    <RefundTypeForm :data="empty" @save="onSave" :save_text="$pgettext('form', 'Create')"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {SuccessNotification} from "@/domain/core/exception/exceptions";
import RefundTypeForm from "@/domain/refundType/components/RefundTypeForm.vue";

export default {
  name: 'NewRefundType',
  components: {RefundTypeForm},
  data() {
    return {
      empty: {
        name: {},
        code: '',
        is_active: true,
      }
    }
  },
  methods: {
    ...mapActions('refundType', ['createRefundType']),

    async onSave(data) {
      await this.createRefundType(data)
      await this.$router.push({name: 'refundType.list'})
      throw new SuccessNotification(this.$pgettext('refundType', 'Refund type created!'))
    }
  }
}
</script>
